const BASE_URL = 'https://admin-portfolio.devappis.com/api/v1/'

const endpoints = {
    contact: BASE_URL + 'contact'
};

export default endpoints;